import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export default function MarkdownRenderer({ content, className = '' }) {
  return (
    <div className={`markdown-body space-y-4 ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
        h1: ({node, ...props}) => <h1 className="text-2xl font-bold font-heading mb-2 mt-4" {...props} />,
        h2: ({node, ...props}) => <h2 className="text-xl font-bold font-heading mb-2 mt-4" {...props} />,
        h3: ({node, ...props}) => <h3 className="text-lg font-bold font-heading mb-2 mt-3" {...props} />,
        h4: ({node, ...props}) => <h4 className="text-md font-bold font-heading mb-2 mt-2" {...props} />,
        p: ({node, ...props}) => <p className="text-sm leading-relaxed mb-2" {...props} />,
        ul: ({node, ...props}) => <ul className="list-disc list-inside space-y-1 mb-3" {...props} />,
        ol: ({node, ...props}) => <ol className="list-decimal list-inside space-y-1 mb-3" {...props} />,
        li: ({node, ...props}) => <li className="text-sm ml-2" {...props} />,
        a: ({node, ...props}) => <a className="text-[var(--accent-primary)] hover:underline" target="_blank" rel="noopener noreferrer" {...props} />,
        blockquote: ({node, ...props}) => (
          <blockquote className="border-l-4 border-[var(--accent-primary)] pl-4 italic opacity-80 my-3" {...props} />
        ),
        code: ({node, inline, ...props}) => 
          inline ? (
            <code className="bg-black/10 dark:bg-white/10 rounded px-1.5 py-0.5 text-[0.85em] font-mono" {...props} />
          ) : (
            <pre className="bg-black/8 dark:bg-white/5 rounded-lg p-3 overflow-x-auto text-xs font-mono my-3 border border-black/10 dark:border-white/10">
              <code {...props} />
            </pre>
          ),
        strong: ({node, ...props}) => <strong className="font-semibold" {...props} />,
        em: ({node, ...props}) => <em className="italic" {...props} />,
        del: ({node, ...props}) => <del className="line-through opacity-70" {...props} />,
        hr: ({node, ...props}) => <hr className="border-t border-black/10 dark:border-white/10 my-4" {...props} />,
        img: ({node, ...props}) => <img className="rounded-lg max-w-full h-auto my-3" loading="lazy" {...props} />,
        table: ({node, ...props}) => (
          <div className="overflow-x-auto my-4">
            <table className="min-w-full divide-y divide-black/10 dark:divide-white/10" {...props} />
          </div>
        ),
        thead: ({node, ...props}) => <thead className="bg-black/5 dark:bg-white/5" {...props} />,
        th: ({node, ...props}) => <th className="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wider" {...props} />,
        td: ({node, ...props}) => <td className="px-3 py-2 text-sm whitespace-normal border-b border-black/5 dark:border-white/5" {...props} />
      }}
    >
      {content}
      </ReactMarkdown>
    </div>
  );
}
